export default "__VITE_ASSET__BP2ux6GW__"